import { FC, useCallback, useEffect, useMemo, useState } from "react";
import ErrorModal from "../../components/ErrorModel";
import { urlAreas, urlEmpleados, urlMarcacion, urlMembresias } from "../../app/EndPoints";
import axios, { AxiosResponse } from "axios";
import Preloader from "../../components/Preloader";
import { useNavigate, useParams } from "react-router-dom";
import { GetMembershipDTO } from "../../models/MembershipDTO";
import SettingsModal from "../../components/SettingModal";
import LoginModal from "../../components/LoginModal";
import AreaListPage from "../../components/AreaListPage";
import AreaFormPage from "../../components/AreaFormPage";
import { GetAreaDTO } from "../../models/AreaDTO";
import EmployeeListPage from "../../components/EmployeeListPage";
import { AttendanceMethod, AttendanceStatus, Employee } from "../../app/types";
import EmployeeFormPage from "../../components/EmployeeFormPage";
import EmployeeList from "../../components/EmployeeList";
import AttendanceModal from "../../components/AttendanceModal";


const NoIndex: FC = () => {     
    type View = 'main' | 'areaList' | 'areaForm' | 'employeeList' | 'employeeForm';

    const [areas, setAreas] = useState<GetAreaDTO[]>([]);
    const [employees, setEmployees] = useState<Employee[]>([]);
    const [editingArea, setEditingArea] = useState<GetAreaDTO | null>(null);
    const [editingEmployee, setEditingEmployee] = useState<Employee | null>(null);
    const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);

    const [searchQuery, setSearchQuery] = useState('');
    const [isToken, setisToken] = useState('');
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [idMembership, setidMembership] = useState(0)
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [errorModalContent, setErrorModalContent] = useState({ title: '', message: '' });
    const [view, setView] = useState<View>('main');    
    const [appError, setAppError] = useState<{ title: string; message: string } | null>(null);
    const [isMaxUsers, setisMaxUsers] = useState(0);

    const [notification, setNotification] = useState<{ message: string; key: number } | null>(null);    
    const [isFreeAccessBlocked, setIsFreeAccessBlocked] = useState(false);
    const [isDeviceAllowed, setIsDeviceAllowed] = useState(false);
    const [isFreeAccess,setisFreAcces] =  useState(0);
    const {membership, isocode}: any = useParams();
    const [isEmail,setisEmail] =  useState("");
    const navigate = useNavigate();

    const handleLogout = useCallback(() => {
        setIsAuthenticated(false);
        setIsSettingsOpen(false);    
        window.location.reload();          
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const result = await LoadMembership();         
            setisFreAcces(result?.freedevice || 0)            
            if (result) { 
                if (result.freedevice === 0)
                {
                    await LoadEmployeeforAttendance()
                    setIsFreeAccessBlocked(false)
                }                    
                else
                {
                    setIsFreeAccessBlocked(true)
                    if (localStorage.getItem('isDeviceAllowed') === 'true')
                    {
                        setIsDeviceAllowed(true);
                        await LoadEmployeeforAttendance()
                    }
                    else
                    {
                         setIsDeviceAllowed(false);
                    }
                }
            }
        };

        fetchData();
    }, []);

    const filteredEmployees = useMemo(() => {
        return employees.filter(employee =>
            employee.Name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [employees, searchQuery]);

    const handleSelectEmployee = useCallback((employee: Employee) => {
        setSelectedEmployee(employee);         
    }, []);

    const handleLoginSuccess = useCallback(() => {
        setIsAuthenticated(true);
        setIsLoginModalOpen(false);
        setIsSettingsOpen(true);
    }, []);

    const handleLoginFailure = useCallback((title: string, message: string) => {
        setIsLoginModalOpen(false);
        setErrorModalContent({ title, message });
        setIsErrorModalOpen(true);
    }, []);

    async function LoadAreas() {
        let result = await LoadMembership();     
        let urlApi = urlAreas + "all/" + result?.id;                
        await axios.get(urlApi)        
        .then((respuesta: AxiosResponse<GetAreaDTO[]>) => {                              
            setAreas(respuesta.data)       
        })
        .catch((error) => {            
            console.error(error);
        });
    }
    
    async function LoadEmployee() {
        let result = await LoadMembership();             
        let urlApi = urlEmpleados + "all/" + result?.id;                        
        await axios.get(urlApi)        
        .then((respuesta: AxiosResponse<Employee[]>) => {            
            setEmployees(respuesta.data)       
        })
        .catch((error) => {            
            setAppError({
                title: 'Error Inesperado',
                message: 'Se ha producido un error crítico. Por favor, reintenta la acción o recarga la aplicación.',
            });
            console.error(error);
        });
    }

    async function LoadEmployeeforAttendance() {
        let result = await LoadMembership();             
        let urlApi = urlMarcacion + "employees/" + result?.id;                        
        await axios.get(urlApi)        
        .then((respuesta: AxiosResponse<Employee[]>) => {                
            setEmployees(respuesta.data)       
        })
        .catch((error) => {            
            setAppError({
                title: 'Error Inesperado',
                message: 'Se ha producido un error crítico. Por favor, reintenta la acción o recarga la aplicación.',
            });
            console.error(error);
        });
    }

    async function LoadMembership(): Promise<{ id: number, token: string, freedevice: number, email:string } | null> {
        setIsLoading(true);
        try {
            const urlApi = `${urlMembresias}${isocode}/${membership}`;
            const respuesta: AxiosResponse<GetMembershipDTO> = await axios.get(urlApi);

            if (!respuesta.data) {                
                navigate("/noaccess");
                return null;
            }            

            let id = respuesta.data.id;
            let token = respuesta.data.Token;
            let freedevice = respuesta.data.FreeDevice;
            let email = respuesta.data.Email;
            

            setidMembership(id);     // guardado en estado
            setisToken(token);         // guardado en estado
            setisEmail(email)
            setIsLoading(false);                        
            return { id, token, freedevice, email };    // también lo devuelve
        } catch (error) {
            console.error("Error al cargar membresía:", error);
            return null;
        }
    }

    const handleSettingsClick = () => {
        if (isAuthenticated) {
            setIsSettingsOpen(true);
        } else {
            setIsLoginModalOpen(true);
        }
    };

    const handleNavigateToAreaList = useCallback(async () => {
            setIsSettingsOpen(false);
            await LoadAreas()
            setView('areaList');
    }, []);

    const handleNavigateToEmployeeList = useCallback(async () => {
        setIsSettingsOpen(false);
        if({isocode}.isocode.toLowerCase() === "co"){
            await axios.get("https://pos.appmakos.com:3333/MEMberships/QuantityFunctions/" + {membership}.membership.toLowerCase() + "/28")
            .then(maxUser =>{                
                setisMaxUsers(maxUser.data)
            })
            .catch(resp => {
                setisMaxUsers(0)
            })

        }
        await LoadEmployee()
        setView('employeeList');
    }, []);

    const handleNavigateToEmployeeForm = useCallback(async (employee: Employee | null) => {
        await LoadAreas()
        setEditingEmployee(employee);
        setView('employeeForm');
    }, []);

    const handleNavigateToAreaForm = useCallback((area: GetAreaDTO | null) => {
        setEditingArea(area);
        setView('areaForm');
    }, []);

    const handleSaveArea = useCallback((areaToSave: GetAreaDTO) => {
        if (areaToSave.Id) { // Update
        setAreas(prev => prev.map(a => a.Id === areaToSave.Id ? areaToSave : a));
        } else { // Create
        setAreas(prev => [...prev, { ...areaToSave, id: Date.now() }]);
        }
        setView('areaList');
    }, []);

    const handleSaveEmployee = useCallback((employeeToSave: { id?: number; name: string; role: string; enabled: number }) => {
    if (employeeToSave.id) {
        setEmployees(prev => prev.map(e => e.Id === employeeToSave.id ? { ...e, ...employeeToSave } : e));
    } else {
        const newEmployee: Employee = {
            Id: Date.now(),
            Name: employeeToSave.name,
            AreaName: employeeToSave.role,
            IdArea: 1,
            Enabled : 1,
            Status: 0,
            IdAttendance: 0,           
            Avatar:""
        };
        setEmployees(prev => [...prev, newEmployee]);
    }
    setView('employeeList');
    }, []);

    const handleCloseModal = useCallback(() => {
        setSelectedEmployee(null);
    }, []);
    
    const handleSetFreeAccessBlocked = async (blocked: boolean) => {
        setIsFreeAccessBlocked(blocked);
        let jsonData = {
            "id" : idMembership,
            "freedevice" : blocked ? 1 : 0
        }       
        await axios.patch(urlMembresias + "freeaccess", jsonData) 
        .then(respOK =>{
            setNotification({ message: 'Seguridad Configurada.', key: Date.now() });
        })
        .catch(error => {
            console.error(error)
            setIsFreeAccessBlocked(!blocked);
            setNotification({ message: 'Ocurrio un error.', key: Date.now() });
        })
    };

    const handleAllowDevice = () => {
        setIsDeviceAllowed(true);
        localStorage.setItem('isDeviceAllowed', 'true');
        setNotification({ message: 'Dispositivo permitido exitosamente.', key: Date.now() });
    };
  
    const handleRemoveDevice = () => {
        setIsDeviceAllowed(false);
        localStorage.removeItem('isDeviceAllowed');
        setNotification({ message: 'Este dispositivo ya no está permitido.', key: Date.now() });
    };

    const renderContent = () => {
        switch (view) {
            case 'areaList':
                return <AreaListPage areas={areas} idMembership={idMembership} onEdit={handleNavigateToAreaForm} onAddNew={() => handleNavigateToAreaForm(null)} onBack={() => setView('main')} />;
            case 'areaForm':
                return <AreaFormPage areaToEdit={editingArea} idMembership={idMembership} onSave={handleSaveArea} onCancel={() => setView('areaList')} onRefresh={LoadAreas} />;
            case 'employeeList':
                return <EmployeeListPage maxUser={isMaxUsers} employees={employees} idMembership={idMembership} onEdit={handleNavigateToEmployeeForm} onAddNew={() => handleNavigateToEmployeeForm(null)} onBack={() => setView('main')} />;
            case 'employeeForm':
                return <EmployeeFormPage areas={areas} idMembership={idMembership} employeeToEdit={editingEmployee} onSave={handleSaveEmployee} onCancel={() => setView('employeeList')} onRefresh={LoadEmployee}/>;
            case 'main':
            default:
                return <EmployeeList email={isEmail} employees={filteredEmployees} onSelectEmployee={handleSelectEmployee} />;            
        }
    };

    return (
        <>
            <Preloader isShowing={isLoading} Text="Cargando . . ." />
            <div className="min-h-screen bg-background dark:bg-dark-background text-on-background dark:text-dark-on-background transition-colors duration-300">
                <header className="bg-surface-container-low dark:bg-dark-surface-container-low sticky top-0 z-20 shadow-sm">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center gap-4">
                        <div className="flex items-center gap-3 flex-shrink-0">                  
                            <img src="https://helpdeskmakos.com/img/yellow/favicon192.png" alt="Makos" style={{width:'64px'}} />
                            <div>
                                <h1 className="text-xl font-medium text-on-surface dark:text-dark-on-surface">Control de Asistencia</h1>                        
                                <p className="text-sm text-on-surface-variant dark:text-dark-on-surface-variant mt-1 hidden md:block">Makos Clock</p>
                            </div>
                        </div>

                        {view === 'main' && (
                            <div className="flex-grow flex justify-center px-4">
                                <div className="relative w-full max-w-md">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <input 
                                        type="search"
                                        placeholder="Buscar empleado..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="w-full bg-surface-container-high dark:bg-dark-surface-container-high text-on-surface-variant dark:text-dark-on-surface-variant placeholder-on-surface-variant dark:placeholder-dark-on-surface-variant rounded-full pl-10 pr-4 py-2 border-2 border-transparent focus:outline-none focus:ring-2 focus:ring-primary dark:focus:ring-dark-primary focus:border-transparent transition-all"
                                    />
                                </div>
                            </div>
                        )}

                        <button onClick={handleSettingsClick} className="p-2 rounded-full text-on-surface-variant dark:text-dark-on-surface-variant hover:bg-primary/10 dark:hover:bg-dark-primary/10 transition-colors flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </button>
                    </div>
                </header>

                <main className="container mx-auto p-4 sm:p-6 lg:p-8">
                    {renderContent()}
                </main>

                <ErrorModal
                    isOpen={isErrorModalOpen}
                    onClose={() => setIsErrorModalOpen(false)}
                    title={errorModalContent.title}
                    message={errorModalContent.message}
                />
            </div>

            {selectedEmployee && (
                <AttendanceModal
                    employee={selectedEmployee}
                    onClose={handleCloseModal}
                    email={isEmail}
                    onReload={() => LoadEmployeeforAttendance()}
                />
            )}

            <LoginModal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
                token={isToken}
                onLoginSuccess={handleLoginSuccess}
                onLoginFailure={handleLoginFailure}
            />           
            
            <SettingsModal 
                isOpen={isSettingsOpen}
                onClose={() => setIsSettingsOpen(false)}
                isFreeAccessBlocked={isFreeAccessBlocked}
                setIsFreeAccessBlocked={handleSetFreeAccessBlocked}
                isDeviceAllowed={isDeviceAllowed}
                onAllowDevice={handleAllowDevice}
                onRemoveDevice={handleRemoveDevice}
                onLogout={handleLogout}                
                onNavigateToAreaList={handleNavigateToAreaList}
                onNavigateToEmployeeList={handleNavigateToEmployeeList}
            />

            {notification && (
                <div key={notification.key} className="fixed bottom-5 right-5 z-50 bg-inverse-surface dark:bg-dark-inverse-surface text-inverse-on-surface dark:text-dark-inverse-on-surface py-3 px-6 rounded-xl shadow-lg animate-fade-in-out">
                <p className="font-medium text-sm">{notification.message}</p>
                </div>
            )}
        </>
    )
}  
export default NoIndex;